(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickDialogController', BrickDialogController);

    BrickDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Brick'];

    function BrickDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Brick) {
        var vm = this;
        vm.brick = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:brickUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.brick.id !== null) {
                Brick.update(vm.brick, onSaveSuccess, onSaveError);
            } else {
                Brick.save(vm.brick, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
